// The version stamped into every saved project (`projectJson.version`).
//
// It exists so a later change of shape can be migrated. Without it, a stored project cannot be
// told apart from one written by an older build: you can sometimes guess from the presence of a
// field, but that guess gets less reliable with every change, and it is unavailable for exactly
// the projects a migration needs to convert.
//
// Adding it costs one line today. Adding it after clients have saved projects does not work —
// those rows are already written without it.
const PROJECT_FORMAT_VERSION = 1;

// What a project saved before versioning reads as. Zero rather than 1, so a migration can tell
// "written before this field existed" from "written as version 1".
const UNVERSIONED_PROJECT_FORMAT = 0;

function readProjectFormatVersion(projectJson: Record<string, unknown>): number {
    return typeof projectJson.version === 'number' ? projectJson.version : UNVERSIONED_PROJECT_FORMAT;
}

export { PROJECT_FORMAT_VERSION, readProjectFormatVersion, UNVERSIONED_PROJECT_FORMAT };
